import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { getSessionStorage, setSessionStorage } from 'src/app/functions/generics';
import { CognitoAttributes } from 'src/app/models/cognito-attributes/cognito-attributes.model.js';
import { CognitoUser } from 'src/app/models/cognito-user/cognito-user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CognitoService } from 'src/app/services/cognito/cognito.service';
import { PIPE_DATE_YEAR_MONTH_DAY_HOURS_MINS_SECONDS, PIPE_DATE_YEAR_MONTH_DAY, SESSION_SELECTED_POOL_NAME } from '../../../utils/const/const';

@Component({
  selector: 'app-details-user',
  templateUrl: './details-user.component.html',
  styleUrls: ['./details-user.component.css']
})
export class DetailsUserComponent implements OnInit {

  cognitoUser: CognitoUser;
  formatDateWithHours = PIPE_DATE_YEAR_MONTH_DAY_HOURS_MINS_SECONDS;
  formatDate = PIPE_DATE_YEAR_MONTH_DAY;
  attributesCustom: Array<CognitoAttributes>

  constructor(private router: Router, private activatedRoute: ActivatedRoute, public authService: AuthService,
    private cognitoService: CognitoService) {
  }

  async ngOnInit() {
    await this.loadCognitoUser();
    if (this.cognitoUser == null) {
      return;
    }
    this.prepareAttributesCustom();
  }

  //El listado de usuarios ya no devuelve los grupos por usuario para no encarecer la llamada.
  //Aquí pedimos el usuario individual al endpoint /user/{poolId}/{username} que sí incluye GroupName.
  async loadCognitoUser() {
    const usuarioSession: CognitoUser = getSessionStorage("detailsUser");
    if (usuarioSession == null || !usuarioSession.Username) {
      this.router.navigate(['..'], { relativeTo: this.activatedRoute });
      return;
    }

    const selectedPool = getSessionStorage(SESSION_SELECTED_POOL_NAME);
    const poolId = selectedPool ? selectedPool.poolId : null;

    try {
      const respuesta = await this.cognitoService.getUser(poolId, usuarioSession.Username).toPromise();
      if (respuesta && respuesta.Users && respuesta.Users.length > 0) {
        this.cognitoUser = respuesta.Users[0];
      } else {
        this.cognitoUser = usuarioSession;
      }
    } catch (error) {
      //Si la llamada falla, caemos al objeto del listado para no dejar al usuario sin la vista.
      this.cognitoUser = usuarioSession;
    }
  }

  goToEditUser() {
    setSessionStorage("editUser", this.cognitoUser);
    setSessionStorage("editView", true);
    this.router.navigate(['..', 'new-user'], { relativeTo: this.activatedRoute.parent });
  }

  prepareAttributesCustom() {
    this.attributesCustom = new Array<CognitoAttributes>();
    this.cognitoUser.Attributes.forEach(attributes => {
      if (attributes.Name.includes('custom')) {
        this.attributesCustom.push(attributes);
      }
    });
  }

}
